import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getOrders = async id => {
  const { data: orderId, error: orderError } = await supabase
    .from('orders')
    .select('transaction_id')
    .eq('id', id)
    .eq('status', 'Completed')
    .maybeSingle();

  if (orderError) {
    throw new Error(`Error fetching orders: ${orderError.message}`);
  }

  return orderId;
};

export default function useGetOrderById(id) {
  return useQuery({
    queryKey: ['useGetOrderById', id],
    queryFn: () => getOrders(id),
    staleTime: 0,
    enabled: !!id,
  });
}
